export const AUTHED = 'AUTHED'
export const NUMBER_VERIFY = 'NUMBER_VERIFY';
export const PIN_VERIFY = 'PIN_VERIFY';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const LOGIN_PATH_NAME = 'LOGIN_PATH_NAME';
export const TIME_OUT = 'TIME_OUT';
export const PHONE_NUMBER = 'PHONE_NUMBER';
export const PIN_CODE = 'PIN_CODE';
export const ROUTES = 'ROUTES';
export const PASSWORD = 'PASSWORD';
export const AUTH_ERROR_MSG = 'AUTH_ERROR_MSG';
export const IS_HR = 'IS_HR';